export default __webpack_public_path__ + "static/media/Group 6497@3x.6624fd64.png";